import { Component, Input, ChangeDetectorRef, ViewChild, Inject } from '@angular/core';
import { AppService } from '../../../app.service';
import { GlobalLabels, CurrentSelection, SelectionLists, Customer, JobSite, Equipment, Family, Make, Model, SearchItem, SearchFavorite, FavOperation, favPopUpModel } from '../../../entities';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';
import { TranslateService } from '../../../translate';
import { Subscription } from 'rxjs/Subscription';
import { trigger, style, animate, transition } from '@angular/animations';
import { FavouriteDialogService } from '../../../../app/modules/GET_NEW_UI/favourite-dialog/favourite-dialog.service';
import { DigitalFormUserAlertComponent } from '../../../../app/modules/GET_NEW_UI/digital-form-search/digital-form-user-alert/digital-form-user-alert.component';
import { PreferencesService } from '../../../../app/modules/preferences/preferences.service';
@Component({
    selector: 'header-top',
    templateUrl: './header-top.component.html',
    styleUrls: ['./header-top.component.scss'],
    animations: [
        trigger(
            'enterAnimation', [
            transition(':enter', [
                style({ height: '1px', opacity: 0 }),
                animate('250ms', style({ height: '324px', opacity: 1 }))
            ]),
            transition(':leave', [
                style({ height: '324px', opacity: 1 }),
                animate('250ms', style({ height: '1px', opacity: 0 }))
            ])
        ]
        )],
    providers: [
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
        { provide: MAT_DATE_LOCALE, useValue: 'en-au' },
    ],
})
export class HeaderTopComponent {
    showSearch: boolean = true;
    showDateInputs: boolean = false;
    @Input() labels: GlobalLabels;
    @Input() WorkshopRepair: boolean = false;
    @Input() showWval: boolean = true;
    @Input() inspectionType: 'temperature' | 'thermography' | 'other';
    ComponentList = [{
        Id: 0,
        Name: "All"
    },
    {

        Id: 1,
        Name: "Chain"
    },
    {
        Id: 2,
        Name: "Idler"
    },
    {
        Id: 3,
        Name: "Frame"
    },

    ]

    currentSelection: CurrentSelection = new CurrentSelection();
    selectionLists: SelectionLists = new SelectionLists();
    multipleSelections: SearchItem[] = [{ Id: 8, SearchId: 1, SearchStr: "", Title: "Evaluation A" }, { Id: 9, SearchId: 1, SearchStr: "", Title: "Evaluation B" }, { Id: 10, SearchId: 1, SearchStr: "", Title: "Evaluation C" }, { Id: 11, SearchId: 1, SearchStr: "", Title: 'Evaluation X' }, { Id: 26, SearchId: 1, SearchStr: "", Title: 'Evaluation MR' }, { Id: 11, SearchId: 27, SearchStr: "", Title: 'Evaluation M' }];
    userName: string;
    userFavorites: SearchFavorite[] = [];
    customerCtrl: FormControl;
    jobsiteCtrl: FormControl;
    equipmentCtrl: FormControl;
    selectedComponentType: number = 0;
    familyCtrl: FormControl;
    makeCtrl: FormControl;
    modelCtrl: FormControl;

    examinerCtrl: FormControl;
    dealerCtrl: FormControl;

    customerInputModel: string;
    jobsiteInputModel: string;
    equipmentInputModel: string;

    filteredCustomers: Observable<Customer[]>;
    filteredJobsites: Observable<JobSite[]>;
    filteredEquipments: Observable<Equipment[]>;
    filteredFamilies: Observable<Family[]>;
    filteredMakes: Observable<Make[]>;
    filteredModels: Observable<Model[]>;
    filteredExaminers: Observable<Customer[]>;
    filteredDealer: Observable<Customer[]>;

    internalLimitedJobSites: JobSite[];
    internalLimitedEquipments: Equipment[];
    internalLimitedModels: Model[];
    internalLimitedCustomers: Customer[];

    startDate: Date;
    endDate: Date;
    JobSiteforFleetconfiguration: JobSite = new JobSite()
    filterMakeModelFamilyForExistingOnly = true;

    isNotUnsyncInspection = false;

    StartDateControl = new FormControl(moment());
    EndDateControl = new FormControl(moment());
    eqSearch: string = "";
    eqNotInUseSearch: string = "";
    eqNotInUseSearch_: boolean = false;

    translateSubscription: Subscription;
    userLanguage = 'english';
    @ViewChild('customerAutoCompleteInput', { read: MatAutocompleteTrigger })
    customerTrigger: MatAutocompleteTrigger;
    @ViewChild('jobSiteAutoCompleteInput', { read: MatAutocompleteTrigger })
    jobSiteTrigger: MatAutocompleteTrigger;
    @ViewChild('equipmentAutoCompleteInput', { read: MatAutocompleteTrigger })
    equipmentTrigger: MatAutocompleteTrigger;
    @ViewChild('makeAutoCompleteInput', { read: MatAutocompleteTrigger })
    makeTrigger: MatAutocompleteTrigger;
    @ViewChild('familyAutoCompleteInput', { read: MatAutocompleteTrigger })
    familyTrigger: MatAutocompleteTrigger;
    @ViewChild('modelAutoCompleteInput', { read: MatAutocompleteTrigger })
    modelTrigger: MatAutocompleteTrigger;
    @ViewChild('examinerAutoCompleteInput', { read: MatAutocompleteTrigger })
    examinerTrigger: MatAutocompleteTrigger;
    @ViewChild('dealerAutoCompleteInput', { read: MatAutocompleteTrigger })
    dealerTrigger: MatAutocompleteTrigger;
    //separatorKeysCodes = [ENTER, COMMA];
    numberofNotifications: number
    showText: boolean = false
    selectedJobsiteForInput: JobSite = new JobSite();
    EnableDashboardAlerts: boolean = false
    constructor(private _pref: PreferencesService, private _dialog: MatDialog, public _favouriteDialogService: FavouriteDialogService, private _appService: AppService, private ref: ChangeDetectorRef, private _evalService: CustomEvalService,
        private _translate: TranslateService,
        private _sharedService: SharedService,
        private _crypto: CryptoService,
        public dialog: MatDialog, private router: ActivatedRoute) {
        this.customerCtrl = new FormControl();
        this.jobsiteCtrl = new FormControl();
        this.equipmentCtrl = new FormControl();
        this.familyCtrl = new FormControl();
        this.makeCtrl = new FormControl();
        this.modelCtrl = new FormControl();
        this.examinerCtrl = new FormControl();
        this.dealerCtrl = new FormControl();

    }

    setInitialDates() {
        this.startDate = this.defaultSearchStartDate;
        this.endDate = this.defaultSearchEndDate;
        this.selectedComponentType = 0;
        this.wSREStatusID = [7];
        console.log("Type:", this.selectedComponentType)
    }

    ngOnInit() {

        this._evalService.LoadWsreStatus().subscribe(res => {
            this.WSREStatus = res;

            //this.wSREStatusID= this.WSREStatus[0].StatusId;
            if (!this.wSREStatusID || this.wSREStatusID.length === 0) {
                this.wSREStatusID = [7];
            }
            this.setInitialDates();
        })



        this.getUserAlertsforDashbpard();
        this._appService.GetLoggedInUserName().subscribe(result => { this.userName = result });
        // this._appService.getCustomerListForSelection(1, 10000).subscribe(result => { this.selectionLists.customerList = result; this.customerCtrl.reset(); });
        this._appService.getDealerForSelection(1, 10000).subscribe(result => {
            this.selectionLists.dealerList = result; this.dealerCtrl.reset();
        });

        this._appService.getCustomerListForSelection(1, 10000).subscribe(result => { this.selectionLists.customerList = result; this.internalLimitedCustomers = result; this.customerCtrl.reset(); });
        this._appService.getJobSiteListForSelection(1, 10000).subscribe(result => { this.selectionLists.jobSiteList = result; this.internalLimitedJobSites = result; this.jobsiteCtrl.reset(); });
        this._appService.getEquipmentListForSelection(1, 20000).subscribe(result => { this.selectionLists.equipmentList = result; this.internalLimitedEquipments = result; });



        this._appService.getFamilyListForSelection(1, 10000).subscribe(result => {
            this.selectionLists.familyList = this.filterMakeModelFamilyForExistingOnly ?
                result.filter(m => m.ExistingCount > 0) : result; this.familyCtrl.reset();
        });

        this._appService.getMakeListForSelection(1, 10000).subscribe(result => { this.selectionLists.makeList = this.filterMakeModelFamilyForExistingOnly ? result.filter(m => m.ExistingCount > 0) : result; this.makeCtrl.reset(); });
        this._appService.getGeneralInspectionInspectors().subscribe(result => {
            console.log("result: ", result);
            this.selectionLists.examinerList = result;
            this.selectionLists.examinerList.forEach(item => {
                item.EncryptedTitle = item.Title;
                item.Title = this._crypto.decrypt(item.Title);
            });
            console.log("this.selectionLists.examinerList: ", this.selectionLists.examinerList);
            this.examinerCtrl.reset();
        });

        this._appService.getModelListForSelection(1, 10000).subscribe(result => {
            this.selectionLists.modelList = this.filterMakeModelFamilyForExistingOnly ?
                result.filter(m => m).filter(m => m.ExistingCount > 0) : result.filter(m => m);

            this.internalLimitedModels = this.filterMakeModelFamilyForExistingOnly ?
                result.filter(m => m).filter(m => m.ExistingCount > 0) : result.filter(m => m); this.modelCtrl.reset();
        });

        this._appService.getUserSearchFavorites(1).subscribe(result => {
            this.userFavorites = result;
            //load default Favourite
            var checkDefaultFav = this.userFavorites.filter(f => f.isDefaultFavourite == true)

            if (checkDefaultFav.length > 0) {
                this.getFavorite(checkDefaultFav[0].Id);

            }
            //end code
        }, error => console.log(error), () => { });

        // this._appService.searchComponentIsExpanded.subscribe(isExpanded => {
        //     console.log("this.showSearch",this.showSearch)
        //     console.log("this.isExpanded",isExpanded)

        //     this.showSearch = isExpanded
        // });
        this._appService.showSearchComponentDateInputs.subscribe(showDateInputs => {
            this.showDateInputs = showDateInputs;
        });
        this._appService.showUserFilter.subscribe(showUser => {
            this.setSelectedTabs(showUser);
        });

        this.filteredCustomers =
            this.customerCtrl.valueChanges
                .startWith(null)
                .map(customerInput => customerInput ? this.filterCustomers(customerInput) : this.resetCustomer());
        this.filteredJobsites = this.jobsiteCtrl.valueChanges
            .startWith(null)
            .map(jobsiteInput => jobsiteInput ? this.filterJobsites(jobsiteInput) : this.resetJobsite());
        this.filteredEquipments = this.equipmentCtrl.valueChanges
            .startWith(null)
            .map(equipmentInput => equipmentInput ? this.filterEquipments(equipmentInput) : this.resetEquipment());
        this.filteredFamilies =
            this.familyCtrl.valueChanges
                .startWith(null)
                .map(familyInput => familyInput ? this.filterFamilies(familyInput) : this.resetFamily());
        this.filteredMakes =
            this.makeCtrl.valueChanges
                .startWith(null)
                .map(makeInput => makeInput ? this.filterMakes(makeInput) : this.resetMake());
        this.filteredModels =
            this.modelCtrl.valueChanges
                .startWith(null)
                .map(modelInput => modelInput ? this.filterModels(modelInput) : this.resetModel());
        this.filteredExaminers =
            this.examinerCtrl.valueChanges
                .startWith(null)
                .map(examinerInput => examinerInput ? this.filterExaminers(examinerInput) : this.resetExaminer());
        this.filteredDealer =
            this.dealerCtrl.valueChanges
                .startWith(null)
                .map(dealerInput => dealerInput ? this.filterDealer(dealerInput) : this.resetDealer());
        this.translateSubscription = this._translate._getPrefLang().subscribe(lang => setTimeout(() => { this.updateUserLang(lang); }, 2));
        this.multipleSelections = this._appService.getLastSelectionSearchItems();
        this.ref.detectChanges();
    }
    WSREStatus: WSreStatusModel[];
    wSREStatusID: number[] = [7];

    searchIsVisible(show: boolean) {
        this._appService.setSearchComponentExpandedStatus(show);
    }


    updateUserLang(lang: string) {
        this.userLanguage = lang;
        this.ref.detectChanges();
    }

    Translate(value: string): string {
        return this._translate.translateToLang(value, this.userLanguage);
    }
    focus(item) {
        switch (item) {
            case 1:
                this.customerTrigger.openPanel();
                break;
            case 2:
                this.jobSiteTrigger.openPanel();
                break;
            case 3:
                this.equipmentTrigger.openPanel();
                break;
            case 4:
                this.familyTrigger.openPanel();
                break;
            case 5:
                this.makeTrigger.openPanel();
                break;
            case 6:
                this.modelTrigger.openPanel();
                break;
            case 20:
                this.examinerTrigger.openPanel();
                break;
            case 21:
                this.dealerTrigger.openPanel();
                break;
        }
    }

    ChangeselectedComponentType(h) {
        this.selectedComponentType = h.value
    }

    pushMultipleSelection(itemId: number, searchId: number, searchText: string): void {

        if ((searchId === 0 && searchText.length === 0))
            return;
        console.log('itemId ' + itemId + '  search Id ' + searchId + ' searvh text ' + searchText)
        const currentSearchItem = this._appService.getSearchItems().find(m => m.Id === itemId);
        if (!currentSearchItem) return;

        // If the item isn't a date
        if (itemId !== 12 && itemId !== 13 && itemId !== 22 && itemId !== 23) {
            const index = this.multipleSelections.findIndex(m => m.Id === itemId && (m.SearchId === searchId || m.SearchStr.toLowerCase() === searchText.toLowerCase()));
            if (index >= 0 && itemId !== 20) return;
        } else if (itemId == 22) {
            this.multipleSelections = this.multipleSelections.filter(x => x.Id != 22);
        }
        else if (itemId == 23) {
            this.multipleSelections = this.multipleSelections.filter(x => x.Id != 23);
        }
        else {
            const index = this.multipleSelections.findIndex(m => m.Id === itemId);
            this.multipleSelections.splice(index, 1);
        }
        const item = new SearchItem();
        item.Id = itemId; item.SearchId = searchId;
        item.SearchStr = searchText;
        item.Title = itemId == 20 ? this._crypto.decrypt(searchText) : searchText;
        this.multipleSelections.push(item);

        console.log("this.multiple__", this.multipleSelections, item)
    }

    popMultipleSelection(itemId: number, searchId: number, searchText: string) {
        console.log("searchId", searchId, searchText.length)
        if (searchId === 0 && searchText.length === 0)
            return;
        const currentSearchItem = this._appService.getSearchItems().find(m => m.Id === itemId);
        if (!currentSearchItem) return;
        const index = this.multipleSelections.findIndex(m => m.Id === itemId && (m.SearchId === searchId || m.SearchStr.toLowerCase() === searchText.toLowerCase()));
        if (index < 0) return;
        this.multipleSelections.splice(index, 1);
        this.resetControlBySearchId(itemId);

    }

    resetControlBySearchId(itemId: number): void {
        switch (itemId) {
            case 1: // 1 -> Customer
                this.customerCtrl.reset();
                this.jobsiteCtrl.reset();
                this.equipmentCtrl.reset();
                break;
            case 2: // 2 -> Jobsite
                this.jobsiteCtrl.reset();
                this.equipmentCtrl.reset();
                this.filteredEquipments = Observable.of(this.selectionLists.equipmentList);
                break;
            case 3: // 3 -> Equpment
                this.equipmentCtrl.reset();
                this.filteredEquipments = Observable.of(this.selectionLists.equipmentList);
                break;
            case 4: // 4 -> Family
                this.familyCtrl.reset();
                this.modelCtrl.reset();
                break;
            case 5: // 5 -> Make
                this.makeCtrl.reset();
                this.modelCtrl.reset();
                break;
            case 6: // 6 -> Model
                this.modelCtrl.reset();
                break;
            case 20: // 20 -> Examiner
                this.examinerCtrl.reset();
                break;
            case 21: // 21 -> Dealer
                this.customerCtrl.reset();
                this.jobsiteCtrl.reset();
                this.equipmentCtrl.reset();
                this.dealerCtrl.reset();
        }
    }

    filterCustomers(userText: any) {
        // console.log('filterCustomers', userText);
        let txt = '';
        if (userText.Title)
            txt = userText.Title;
        else txt = userText;
        return this.selectionLists.customerList.filter(cust =>
            cust.Title.toLowerCase().indexOf(txt.toLowerCase()) === 0
            && (this.multipleSelections.findIndex(m => m.Id === 1 && (m.SearchId === cust.Id || m.SearchStr.toLowerCase() === cust.Title.toLowerCase())) < 0)
        );
    }

    getPushedSelections(itemId): SearchItem[] {
        let arr = this.multipleSelections.filter(m => m.Id === itemId);

        return arr
    }
    customerSelected(selected, input) {
        if (input)
            input.value = '';

        this.selectedJobsiteForInput.CustomerId = selected.option.value.Id
        this.currentSelection.customer.Id = selected.option.value.Id;
        this.currentSelection.customer.Title = selected.option.value.Title;
        //fleet configuration filter
        this.JobSiteforFleetconfiguration.CustomerId = selected.option.value.Id;
        this._sharedService.setCustomerInfo(this.JobSiteforFleetconfiguration);
        this.pushMultipleSelection(1, selected.option.value.Id, selected.option.value.Title);
        this.internalLimitedJobSites = this.selectionLists.jobSiteList.filter(jobsite =>
            this.multipleSelections.findIndex(m => m.Id === 1 && (jobsite.CustomerId === m.SearchId)) >= 0);
        this.customerCtrl.reset();
    }
    resetCustomer(): Customer[] {
        // console.log('resetCustomer');
        this.currentSelection.customer = new Customer();
        this.internalLimitedJobSites = this.selectionLists.jobSiteList.filter(jobsite =>
            this.multipleSelections.findIndex(m => m.Id === 1 && (jobsite.CustomerId === m.SearchId)) >= 0);
        this.jobsiteCtrl.reset();

        // return this.selectionLists.customerList.filter(cust =>
        //     (this.multipleSelections.findIndex(m => m.Id === 1 && (m.SearchId === cust.Id || m.SearchStr.toLowerCase() === cust.Title.toLowerCase())) < 0)
        // );

        if (this.multipleSelections.filter(m => m.Id === 21).length === 0)
            return this.selectionLists.customerList.filter(cust => this.multipleSelections.findIndex(m => m.Id === 1 && (m.SearchId === cust.Id || m.SearchStr === cust.Title)) < 0);

        if (this.multipleSelections.filter(m => m.Id === 21).length > 0)
            return this.selectionLists.customerList.filter(cust =>
                this.multipleSelections.findIndex(m => m.Id === 1 && (m.SearchId === cust.Id || m.SearchStr === cust.Title)) < 0
                && this.multipleSelections.findIndex(m => m.Id === 21 && (m.SearchId === cust.DealerId)) >= 0);

        return this.selectionLists.customerList.filter(cust =>
            this.multipleSelections.findIndex(m => m.Id === 1 && (m.SearchId === cust.Id || m.SearchStr === cust.Title)) < 0
            && this.multipleSelections.findIndex(m => m.Id === 21 && (m.SearchId === cust.DealerId)) >= 0);


    }

    resetExaminer(): Customer[] {
        // console.log('resetCustomer');
        this.currentSelection.examiner = new Customer();

        return this.selectionLists.examinerList.filter(exam =>
            (this.multipleSelections.findIndex(m => m.Id === 20 && (m.SearchId === exam.Id || m.SearchStr.toLowerCase() === exam.Title.toLowerCase())) < 0)
        );
    }


    setSelectedTabs(inspectionTypes: ViewedInspectionTypes) {
        switch (inspectionTypes) {
            case ViewedInspectionTypes.GeneralInspection:
                this.isNotUnsyncInspection = true;
                this._appService.getGeneralInspectionInspectors().subscribe(r => {
                    console.log("getGeneralInspectionInspectors: ", r);
                    this.selectionLists.examinerList = r;
                    this.selectionLists.examinerList.forEach(item => {
                        item.EncryptedTitle = item.Title;

                        //console.log("this._crypto.decrypt(item.Title):",this._crypto.decrypt(item.Title),item.Title);
                        item.Title = this._crypto.decrypt(item.Title);
                    });
                    this.filteredExaminers =
                        this.examinerCtrl.valueChanges
                            .startWith(null)
                            .map(examinerInput => examinerInput ? this.filterExaminers(examinerInput) : this.resetExaminer());
                    //console.log("this.filteredExaminers:",this.filteredExaminers);
                });

                break;
            case ViewedInspectionTypes.RepairEstimates:
                this.isNotUnsyncInspection = true;
                break;
            case ViewedInspectionTypes.UnsyncInspection:
                this.isNotUnsyncInspection = false;
                break;
        }
    }

    filterJobsites(userText: any) {
        // console.log('filterJobsites', userText);
        let txt = '';
        if (userText.Title)
            txt = userText.Title;
        else txt = userText;
        return this.internalLimitedJobSites.filter(jobsite =>
            jobsite.Title.toLowerCase().indexOf(txt.toLowerCase()) === 0
            && (this.multipleSelections.findIndex(m => m.Id === 2 && (m.SearchId === jobsite.Id || m.SearchStr.toLowerCase() === jobsite.Title.toLowerCase())) < 0)
        );
    }
    jobsiteSelected(selected, input) {
        if (input)
            input.value = '';

        this.selectedJobsiteForInput.Id = selected.option.value.Id
        this.currentSelection.jobSite.Id = selected.option.value.Id;
        this.currentSelection.jobSite.Title = selected.option.value.Title;
        this.pushMultipleSelection(2, selected.option.value.Id, selected.option.value.Title);
        this.JobSiteforFleetconfiguration.Id = selected.option.value.Id
        this._sharedService.setCustomerInfo(this.JobSiteforFleetconfiguration);

        this.internalLimitedEquipments = this.selectionLists.equipmentList.filter(equipment =>
            this.multipleSelections.findIndex(m => m.Id === 2 && (equipment.JobSiteId === m.SearchId)) >= 0);
        this.filteredEquipments = Observable.of(this.internalLimitedEquipments);
        this.jobsiteCtrl.reset();
    }

    resetJobsite(): JobSite[] {
        // console.log('resetJobsite', this.internalLimitedJobSites);
        this.currentSelection.jobSite = new JobSite();
        if (!this.internalLimitedJobSites) return [];
        this.internalLimitedEquipments = this.selectionLists.equipmentList.filter(equipment =>
            this.multipleSelections.findIndex(m => m.Id === 2 && (equipment.JobSiteId === m.SearchId)) >= 0);
        this.equipmentCtrl.reset();
        return this.internalLimitedJobSites.filter(jobsite =>
            (this.multipleSelections.findIndex(m => m.Id === 2 && (m.SearchId === jobsite.Id || m.SearchStr.toLowerCase() === jobsite.Title.toLowerCase())) < 0)
        );
    }

    filterEquipments(userText: any) {
        let txt = '';
        if (userText.Serial)
            txt = userText.Serial;
        else txt = userText;


        return this.internalLimitedEquipments.filter(equipment =>
            ((equipment.Serial.toLowerCase().indexOf(txt.toLowerCase()) === 0) || (equipment.Unit.toLowerCase().indexOf(txt.toLowerCase()) === 0)
                || (equipment.AddiUnit && (equipment.AddiUnit.toLowerCase().indexOf(txt.toLowerCase()) === 0)))
            && (this.multipleSelections.findIndex(m => m.Id === 3 && (m.SearchId === equipment.Id || m.SearchStr.toLowerCase() === equipment.Serial.toLowerCase() ||
                m.SearchStr.toLowerCase() === equipment.AddiUnit.toLowerCase())) < 0)
        );

    }



    resetEquipment(): Equipment[] {
        // console.log('resetEquipment');
        this.currentSelection.equipment = new Equipment();
        if (!this.internalLimitedEquipments) return [];
        return this.internalLimitedEquipments.filter(equipment =>
            (this.multipleSelections.findIndex(m => m.Id === 3 && (m.SearchId === equipment.Id || m.SearchStr.toLowerCase() === equipment.Serial.toLowerCase())) < 0)
        );
    }

    customerDisplayMapper(customer: Customer) {
        return customer ? customer.Title : customer;
    }
    jobsiteDisplayMapper(jobsite: JobSite) {
        return jobsite ? jobsite.Title : jobsite;
    }
    equipmentDisplayMapper(equipment: Equipment) {
        return equipment ? equipment.Serial : equipment;
    }
    examinerDisplayMapper(examiner: Customer) {
        return examiner ? examiner.Title : examiner;
    }
    dealerDisplayMapper(dealer: Customer) {
        return dealer ? dealer.Title : dealer;
    }
    //////Dealer
    filterDealer(userText: any) {
        // console.log('filterCustomers', userText);
        let txt = '';
        if (userText.Title)
            txt = userText.Title;
        else txt = userText;
        return this.selectionLists.dealerList.filter(deal =>
            deal.Title.toLowerCase().indexOf(txt.toLowerCase()) === 0
            && (this.multipleSelections.findIndex(m => m.Id === 21 && (m.SearchId === deal.Id || m.SearchStr.toLowerCase() === deal.Title.toLowerCase())) < 0)
        );


    }

    cTypeSelected(selected, input) {

        if (input)
            input.value = '';
        this.currentSelection.dealer.Id = selected.option.value.Id;
        this.currentSelection.dealer.Title = selected.option.value.Title;
        this.pushMultipleSelection(21, selected.option.value.Id, selected.option.value.Title);
        this.internalLimitedCustomers = this.selectionLists.customerList.filter(cus => {
            if (this.multipleSelections.filter(m => m.Id === 1).length > 0)
                return (this.multipleSelections.findIndex(m => m.Id === 21 && (cus.DealerId === m.SearchId)) >= 0 &&
                    this.multipleSelections.findIndex(m => m.Id === 1 && (cus.Id === m.SearchId)) >= 0);

        });
        this.dealerCtrl.reset();

    }

    dealerSelected(selected, input) {

        if (input)
            input.value = '';
        this.currentSelection.dealer.Id = selected.option.value.Id;
        this.currentSelection.dealer.Title = selected.option.value.Title;
        this.pushMultipleSelection(21, selected.option.value.Id, selected.option.value.Title);
        this.internalLimitedCustomers = this.selectionLists.customerList.filter(cus => {
            if (this.multipleSelections.filter(m => m.Id === 1).length > 0)
                return (this.multipleSelections.findIndex(m => m.Id === 21 && (cus.DealerId === m.SearchId)) >= 0 &&
                    this.multipleSelections.findIndex(m => m.Id === 1 && (cus.Id === m.SearchId)) >= 0);

        });
        this.filteredEquipments = Observable.of(this.selectionLists.equipmentList);
        this.dealerCtrl.reset();


    }
    MakeChangedMain(event: any) {
        if (event.target.value != "") {
            const filterValue = event.target.value.toLowerCase();
            this.internalLimitedEquipments = this.selectionLists.equipmentList.filter(option => option.Unit.toLowerCase().includes(filterValue)
                ||
                option.Serial?.toLowerCase().includes(filterValue.toLowerCase())
            );
            // this.internalLimitedEquipments = this.selectionLists.equipmentList.filter(equipment =>
            //     this.multipleSelections.findIndex(m => m.Id === 2 && (equipment.JobSiteId === m.SearchId)) >= 0);

            this.filteredEquipments = Observable.of(this.internalLimitedEquipments);

        } else {

        }
    }

    resetDealer(): Customer[] {
        // console.log('resetCustomer');
        this.currentSelection.dealer = new Customer();
        if (!this.selectionLists.dealerList) return [];
        this.internalLimitedCustomers = this.selectionLists.customerList.filter(customer =>
            this.multipleSelections.findIndex(m => m.Id === 21 && (customer.Id === m.SearchId)) >= 0);
        this.customerCtrl.reset();
        return this.selectionLists.dealerList.filter(deal =>
            (this.multipleSelections.findIndex(m => m.Id === 21 && (m.SearchId === deal.Id || m.SearchStr.toLowerCase() === deal.Title.toLowerCase())) < 0)
        );

    }


    //////FAMILY MAKE MODEL

    filterFamilies(userText: any) {
        // console.log('filterFamilies', this.selectionLists.familyList);
        let txt = '';
        if (userText.Title)
            txt = userText.Title;
        else txt = userText;

        return this.selectionLists.familyList.filter(family =>
            (family.Title.toLowerCase().indexOf(txt.toLowerCase()) === 0)
            && (this.multipleSelections.findIndex(m => m.Id === 4 && (m.SearchId === family.Id || m.SearchStr.toLowerCase() === family.Title.toLowerCase())) < 0)
        );
    }
    familySelected(selected, input) {

        if (input)
            input.value = '';
        this.currentSelection.family.Id = selected.option.value.Id;
        this.currentSelection.family.Title = selected.option.value.Title;
        this.pushMultipleSelection(4, selected.option.value.Id, selected.option.value.Title);
        this.internalLimitedModels = this.selectionLists.modelList.filter(model => {
            if (this.multipleSelections.filter(m => m.Id === 5).length > 0)
                return (this.multipleSelections.findIndex(m => m.Id === 4 && (model.FamilyId === m.SearchId)) >= 0 && this.multipleSelections.findIndex(m => m.Id === 5 && (model.MakeId === m.SearchId)) >= 0 && this.multipleSelections.findIndex(m => m.Id === 6 && (model.Id === m.SearchId)) < 0);
            return (this.multipleSelections.findIndex(m => m.Id === 4 && (model.FamilyId === m.SearchId)) >= 0 && this.multipleSelections.findIndex(m => m.Id === 6 && (model.Id === m.SearchId)) < 0);
        });
        this.familyCtrl.reset();
    }
    resetFamily(): Family[] {
        // console.log('resetFamily', this.selectionLists.familyList);
        this.currentSelection.family = new Family();
        if (!this.selectionLists.familyList) return [];

        this.internalLimitedModels = this.selectionLists.modelList.filter(model => {
            if (this.multipleSelections.filter(m => m.Id === 5).length > 0)
                return (this.multipleSelections.findIndex(m => m.Id === 4 && (model.FamilyId === m.SearchId)) >= 0 && this.multipleSelections.findIndex(m => m.Id === 5 && (model.MakeId === m.SearchId)) >= 0 && this.multipleSelections.findIndex(m => m.Id === 6 && (model.Id === m.SearchId)) < 0);
            return (this.multipleSelections.findIndex(m => m.Id === 4 && (model.FamilyId === m.SearchId)) >= 0 && this.multipleSelections.findIndex(m => m.Id === 6 && (model.Id === m.SearchId)) < 0);
        });
        this.modelCtrl.reset();
        return this.selectionLists.familyList.filter(family =>
            (this.multipleSelections.findIndex(m => m.Id === 4 && (m.SearchId === family.Id || m.SearchStr.toLowerCase() === family.Title.toLowerCase())) < 0)
        );
    }
    familyDisplayMapper(family: Family) {
        return family ? family.Title : family;
    }

    equipmentSelected(selected, input) {
        console.log('equipmentSelected', selected);

        if (input)
            input.value = '';
        this.currentSelection.equipment.Id = selected.option.value.Id;
        this.currentSelection.equipment.Serial = selected.option.value.Unit;
        this.pushMultipleSelection(3, selected.option.value.Id, selected.option.value.Unit);
        this.equipmentCtrl.reset();
    }

    examinerSelected(selected, input) {

        if (input)
            input.value = '';
        this.currentSelection.examiner.Id = selected.option.value.Id;
        this.currentSelection.examiner.Title = this._crypto.decrypt(selected.option.value.Title);
        this.pushMultipleSelection(20, selected.option.value.Id, this.selectionLists.examinerList.find(x => x.Id === selected.option.value.Id)?.EncryptedTitle || '');
        this.examinerCtrl.reset();
    }
    filterMakes(userText: any) {
        let txt = '';
        if (userText.Title)
            txt = userText.Title;
        else txt = userText;

        return this.selectionLists.makeList.filter(make =>
            (make.Title.toLowerCase().indexOf(txt.toLowerCase()) === 0)
            && (this.multipleSelections.findIndex(m => m.Id === 5 && (m.SearchId === make.Id || m.SearchStr.toLowerCase() === make.Title.toLowerCase())) < 0)
        );
    }
    filterExaminers(userText: any) {
        // console.log('filterCustomers', userText);
        let txt = '';
        if (userText.Title)
            txt = userText.Title;
        else txt = userText;
        return this.selectionLists.examinerList.filter(exam =>
            exam.Title.toLowerCase().indexOf(txt.toLowerCase()) === 0
            && (this.multipleSelections.findIndex(m => m.Id === 20 && (m.SearchId === exam.Id || m.SearchStr.toLowerCase() === exam.Title.toLowerCase())) < 0)
        );
    }
    makeSelected(selected, input) {

        if (input)
            input.value = '';
        this.currentSelection.make.Id = selected.option.value.Id;
        this.currentSelection.make.Title = selected.option.value.Title;

        this.pushMultipleSelection(5, selected.option.value.Id, selected.option.value.Title);
        this.internalLimitedModels = this.selectionLists.modelList.filter(model => {
            if (this.multipleSelections.filter(m => m.Id === 4).length > 0)
                return (this.multipleSelections.findIndex(m => m.Id === 4 && (model.FamilyId === m.SearchId)) >= 0 && this.multipleSelections.findIndex(m => m.Id === 5 && (model.MakeId === m.SearchId)) >= 0 && this.multipleSelections.findIndex(m => m.Id === 6 && (model.Id === m.SearchId)) < 0);
            return (this.multipleSelections.findIndex(m => m.Id === 5 && (model.MakeId === m.SearchId)) >= 0 && this.multipleSelections.findIndex(m => m.Id === 6 && (model.Id === m.SearchId)) < 0);
        });
        this.makeCtrl.reset();
    }
    resetMake(): Make[] {
        this.currentSelection.make = new Make();
        if (!this.selectionLists.makeList) return [];

        this.internalLimitedModels = this.selectionLists.modelList.filter(model => {
            if (this.multipleSelections.filter(m => m.Id === 5).length > 0)
                return (this.multipleSelections.findIndex(m => m.Id === 4 && (model.FamilyId === m.SearchId)) >= 0 && this.multipleSelections.findIndex(m => m.Id === 5 && (model.MakeId === m.SearchId)) >= 0 && this.multipleSelections.findIndex(m => m.Id === 6 && (model.Id === m.SearchId)) < 0);
            return (this.multipleSelections.findIndex(m => m.Id === 4 && (model.FamilyId === m.SearchId)) >= 0 && this.multipleSelections.findIndex(m => m.Id === 6 && (model.Id === m.SearchId)) < 0);
        });
        this.modelCtrl.reset();
        return this.selectionLists.makeList.filter(make =>
            (this.multipleSelections.findIndex(m => m.Id === 5 && (m.SearchId === make.Id || m.SearchStr.toLowerCase() === make.Title.toLowerCase())) < 0)
        );

    }
    makeDisplayMapper(make: Make) {
        return make ? make.Title : make;
    }

    filterModels(userText: any) {
        let txt = '';
        if (userText.Title)
            txt = userText.Title;
        else txt = userText;

        if (this.multipleSelections.filter(m => m.Id === 4).length === 0 && this.multipleSelections.filter(m => m.Id === 5).length === 0)
            return this.selectionLists.modelList.filter(model => model.Title.toLowerCase().indexOf(txt.toLowerCase()) === 0
                && this.multipleSelections.findIndex(m => m.Id === 6 && (m.SearchId === model.Id || m.SearchStr === model.Title)) < 0
            );

        if (this.multipleSelections.filter(m => m.Id === 4).length === 0 && this.multipleSelections.filter(m => m.Id === 5).length > 0)
            return this.selectionLists.modelList.filter(model => model.Title.toLowerCase().indexOf(txt.toLowerCase()) === 0
                && this.multipleSelections.findIndex(m => m.Id === 6 && (m.SearchId === model.Id || m.SearchStr === model.Title)) < 0
                && this.multipleSelections.findIndex(m => m.Id === 5 && (m.SearchId === model.MakeId)) >= 0);

        if (this.multipleSelections.filter(m => m.Id === 4).length > 0 && this.multipleSelections.filter(m => m.Id === 5).length === 0)
            return this.selectionLists.modelList.filter(model => model.Title.toLowerCase().indexOf(txt.toLowerCase()) === 0
                && this.multipleSelections.findIndex(m => m.Id === 6 && (m.SearchId === model.Id || m.SearchStr === model.Title)) < 0
                && this.multipleSelections.findIndex(m => m.Id === 4 && (m.SearchId === model.FamilyId)) >= 0);


        return this.selectionLists.modelList.filter(model => model.Title.toLowerCase().indexOf(txt.toLowerCase()) === 0
            && this.multipleSelections.findIndex(m => m.Id === 6 && (m.SearchId === model.Id || m.SearchStr === model.Title)) < 0
            && this.multipleSelections.findIndex(m => m.Id === 4 && (m.SearchId === model.FamilyId)) >= 0
            && this.multipleSelections.findIndex(m => m.Id === 5 && (m.SearchId === model.MakeId)) >= 0);

    }
    modelSelected(selected, input) {

        if (input)
            input.value = '';
        this.currentSelection.model.Id = selected.option.value.Id;
        this.currentSelection.model.Title = selected.option.value.Title;
        this.pushMultipleSelection(6, selected.option.value.Id, selected.option.value.Title);
        this.modelCtrl.reset();
    }

    checkBoxChanged(item: number, event: any) {
        if (event.checked)
            this.pushMultipleSelection(item, 1, '');
        else this.popMultipleSelection(item, 1, '');
    }

    ChangeEQSearch(item: number, event: any) {
        console.log("vla", event.target.value);
        this.eqSearch = event.target.value;
        if (this.eqSearch != "") {
            this.pushMultipleSelection(item, 22, this.eqSearch);
        } else {
            this.popMultipleSelection(item, 22, '');
        }



    }
    ChangeEqNotInUseSearch(item: number, event: any) {
        // console.log("vla", event.checked);
        this.eqNotInUseSearch_ = event.checked;
        this.eqNotInUseSearch = event.checked.toString();

        if (this.eqNotInUseSearch != "false") {
            this.pushMultipleSelection(item, 23, this.eqNotInUseSearch);
        } else {
            this.popMultipleSelection(item, 23, '');
        }
    }

    resetModel(): Model[] {
        this.currentSelection.model = new Model();


        if (this.multipleSelections.filter(m => m.Id === 4).length === 0 && this.multipleSelections.filter(m => m.Id === 5).length === 0)
            return this.selectionLists.modelList.filter(model => this.multipleSelections.findIndex(m => m.Id === 6 && (m.SearchId === model.Id || m.SearchStr === model.Title)) < 0);

        if (this.multipleSelections.filter(m => m.Id === 4).length === 0 && this.multipleSelections.filter(m => m.Id === 5).length > 0)
            return this.selectionLists.modelList.filter(model =>
                this.multipleSelections.findIndex(m => m.Id === 6 && (m.SearchId === model.Id || m.SearchStr === model.Title)) < 0
                && this.multipleSelections.findIndex(m => m.Id === 5 && (m.SearchId === model.MakeId)) >= 0);

        if (this.multipleSelections.filter(m => m.Id === 4).length > 0 && this.multipleSelections.filter(m => m.Id === 5).length === 0)
            return this.selectionLists.modelList.filter(model =>
                this.multipleSelections.findIndex(m => m.Id === 6 && (m.SearchId === model.Id || m.SearchStr === model.Title)) < 0
                && this.multipleSelections.findIndex(m => m.Id === 4 && (m.SearchId === model.FamilyId)) >= 0);


        return this.selectionLists.modelList.filter(model =>
            this.multipleSelections.findIndex(m => m.Id === 6 && (m.SearchId === model.Id || m.SearchStr === model.Title)) < 0
            && this.multipleSelections.findIndex(m => m.Id === 4 && (m.SearchId === model.FamilyId)) >= 0
            && this.multipleSelections.findIndex(m => m.Id === 5 && (m.SearchId === model.MakeId)) >= 0);
    }
    modelDisplayMapper(model: Model) {
        return model ? model.Title : model;
    }

    submitSelection(): void {

        this.currentSelection = new CurrentSelection();
        const firstCustomer = this.multipleSelections.find(m => m.Id === 1);
        if (firstCustomer) {
            this.currentSelection.customer.Id = firstCustomer.Id;
            this.currentSelection.customer.Title = firstCustomer.Title;
        }

        const firstJobsite = this.multipleSelections.find(m => m.Id === 2);
        if (firstJobsite) {
            this.currentSelection.jobSite.Id = firstJobsite.Id;
            this.currentSelection.jobSite.Title = firstJobsite.Title;
        }
        const firstEquipment = this.multipleSelections.find(m => m.Id === 3);
        if (firstEquipment) {
            this.currentSelection.equipment.Id = firstEquipment.Id;
            this.currentSelection.equipment.Serial = firstEquipment.Title;
        }
        const firstFamily = this.multipleSelections.find(m => m.Id === 4);
        if (firstFamily) {
            this.currentSelection.family.Id = firstFamily.Id;
            this.currentSelection.family.Title = firstFamily.Title;
        }
        const firstMake = this.multipleSelections.find(m => m.Id === 5);
        if (firstMake) {
            this.currentSelection.make.Id = firstMake.Id;
            this.currentSelection.make.Title = firstMake.Title;
        }
        const firstModel = this.multipleSelections.find(m => m.Id === 6);
        if (firstModel) {
            this.currentSelection.model.Id = firstModel.Id;
            this.currentSelection.model.Title = firstModel.Title;
        }

        const firstDealer = this.multipleSelections.find(m => m.Id === 21);
        if (firstDealer) {
            this.currentSelection.dealer.Id = firstDealer.Id;
            this.currentSelection.dealer.Title = firstDealer.Title;
        }


        const firstExaminer = this.multipleSelections.find(m => m.Id === 20);
        if (firstExaminer) {
            this.currentSelection.examiner.Id = firstExaminer.Id;
            this.currentSelection.examiner.Title = firstExaminer.Title;
        }
        this.currentSelection.startDate = this.startDate;
        this.currentSelection.endDate = this.endDate;
        this.currentSelection.componentType = this.selectedComponentType
        // this.currentSelection.lu_UcStatusId= this.wSREStatusID
        const START_DATE = 12;
        const END_DATE = 13;
        this.pushMultipleSelection(START_DATE, -1, this.startDate.toISOString());
        this.pushMultipleSelection(END_DATE, -1, this.endDate.toISOString());

        if (this.wSREStatusID.length === 0) {
            this.currentSelection.lu_UcStatusId = [7];
        } else {
            this.currentSelection.lu_UcStatusId = this.wSREStatusID;
        }
        this._appService.sendSelectionSearchItems(this.includeSearchTexts(this.multipleSelections));
        this._appService.sendEnableSearch(true);
    }

    private includeSearchTexts(_selected: SearchItem[]) {
        const _textItems: SearchItem[] = [];
        if (this.customerCtrl && this.customerCtrl.value)
            // _textItems.push({ Id: 1, SearchId: 0, SearchStr: this.customerCtrl.value, Title: 'Customer' });
            _textItems.push({ Id: 1, SearchId: 0, SearchStr: '', Title: 'Customer' });
        if (this.jobsiteCtrl && this.jobsiteCtrl.value)
            // _textItems.push({ Id: 2, SearchId: 0, SearchStr: this.jobsiteCtrl.value, Title: 'Jobsite' });
            _textItems.push({ Id: 2, SearchId: 0, SearchStr: '', Title: 'Jobsite' });
        if (this.equipmentCtrl && this.equipmentCtrl.value)
            // _textItems.push({ Id: 3, SearchId: 0, SearchStr: this.equipmentCtrl.value, Title: 'Equipment' });
            _textItems.push({ Id: 3, SearchId: 0, SearchStr: '', Title: 'Equipment' });
        if (this.dealerCtrl && this.dealerCtrl.value)
            // _textItems.push({ Id: 1, SearchId: 0, SearchStr: this.customerCtrl.value, Title: 'Customer' });
            _textItems.push({ Id: 21, SearchId: 0, SearchStr: '', Title: 'Dealer' });

        //console.log("this.selectedComponentType", this.selectedComponentType)

        if (this.selectedComponentType > 0) {
            _textItems.push({ Id: 25, SearchId: this.selectedComponentType, SearchStr: this.selectedComponentType == 1 ? "chain" : "idler", Title: 'ComponentType' });
        }
        // if(this.wSREStatusID>0 && this.WorkshopRepair==true){
        //     _textItems.push({Id:24,SearchId:this.wSREStatusID,SearchStr:'',Title:'Status'})
        // }
        if (this.wSREStatusID.length > 0 && this.WorkshopRepair === true) {
            _selected.filter(x => x.SearchId != 7);
            this.wSREStatusID.forEach(statusId => {
                _textItems.push({
                    Id: 24,
                    SearchId: statusId,
                    SearchStr: '',
                    Title: 'Status'
                });
            });
        }
        _textItems.push(..._selected);
        //console.log(_textItems);
        return _textItems;

    }

    StatusChanges(event) {
        if (event.value.length > 0) {
            if (event.value.length == 1 && event.value != 7) {
                this.multipleSelections = this.multipleSelections.filter(x => x.SearchId != 7);
            } else {
                this.wSREStatusID = event.value;
            }
        } else {
            this.wSREStatusID = [];
            this.multipleSelections = this.multipleSelections.filter(x => x.SearchId != 7);
        }

        console.log(this.wSREStatusID);
    }
    openDialog(operation: FavOperation, favorite: SearchFavorite): void {
        // console.log(favorite);
        const dialogRef = this.dialog.open(FavoriteDialog, {
            width: '400px',
            data: { userLanguage: this.userLanguage, operation: operation, favorite: favorite }
        });

        dialogRef.afterClosed().subscribe(result => {
            // console.log('The dialog was closed', result);
            if (!result) return;

            const fav = new favPopUpModel();
            fav.SearchFavorite = result.SearchFavorite;
            fav.SearchFavorite.ModuleId = 1;

            if (result.operation === FavOperation.Delete) {
                this._appService.removeSearchFavorite(fav.SearchFavorite).subscribe(removeResult => {
                    if (!removeResult.ResultMessage.OperationSucceed) {
                        alert(this.Translate('result.ResultMessage.LastMessage'));
                    }
                    this.userFavorites = [];
                    this.userFavorites.push(...removeResult.SearchFavorites);
                }, error => console.error(error));
            } else if (result.operation === FavOperation.Add) {

                fav.SearchFavorite.SearchItems.push(...this.multipleSelections);
                this._appService.addSearchFavorite(fav.SearchFavorite).subscribe(result => {
                    if (!result.ResultMessage.OperationSucceed) {
                        alert(this.Translate('result.ResultMessage.LastMessage'));
                    }
                    this.userFavorites = [];
                    this.userFavorites.push(...result.SearchFavorites);
                }, error => console.error(error));
            } else if (result.operation === FavOperation.Update) {
                fav.SearchFavorite.SearchItems = [];
                fav.SearchFavorite.SearchItems.push(...this.multipleSelections);
                this._appService.updateSearchFavorite(fav.SearchFavorite).subscribe(result => {
                    if (!result.ResultMessage.OperationSucceed) {
                        alert(this.Translate(result.ResultMessage.LastMessage));
                    }
                    this.userFavorites = [];
                    this.userFavorites.push(...result.SearchFavorites);
                    this.submitSelection();
                }, error => console.error(error));
            }


        });
    }

    getFavorite(favId: number) {
        this._appService.getFavoriteItems(favId).subscribe(result => {
            this.resetSelection();
            this.multipleSelections.push(...result);
            this.submitSelection();
        }, error => console.error(error));
    }

    getEvalCheckStatus(itemId: number): boolean {
        const result = this.multipleSelections.filter(m => m.Id === itemId && m.SearchId === 1).length > 0;
        return result;
    }

    showAlertDialog() {
        const dialogRef = this._dialog.open(DigitalFormUserAlertComponent, {
            data: {
                ModuleId: DashBoardModule.UC
            }
        });
        dialogRef.afterClosed().subscribe(res => {
            console.log("res", res)
            this.getUserAlertsforDashbpard();

        });
    }

    getUserAlertsforDashbpard() {
        this._favouriteDialogService.getCurrentUserAlertsforDigitalForms(DashBoardModule.UC).subscribe(res => {
            console.log(res)

            if (res != null) {
                this.numberofNotifications = res.filter(x => x.status == 1).length

                if (this.numberofNotifications == 0) {
                    this.showText = false;
                } else {
                    this.showText = true;
                }
            }
            this._pref.GetDashBoardAlertEnableStatus().subscribe(res => {
                if (res == "True") {
                    this.EnableDashboardAlerts = true;
                } else {
                    this.EnableDashboardAlerts = false;
                }
            });

        })
    }

    resetSelection() {
        this.multipleSelections = [
            { Id: 8, SearchId: 1, SearchStr: '', Title: 'Evaluation A' },
            { Id: 9, SearchId: 1, SearchStr: '', Title: 'Evaluation B' },
            { Id: 10, SearchId: 1, SearchStr: '', Title: 'Evaluation C' },
            { Id: 11, SearchId: 1, SearchStr: '', Title: 'Evaluation X' },
            { Id: 12, SearchId: -1, SearchStr: this.defaultSearchStartDate.toISOString(), Title: 'Start Date' },
            { Id: 13, SearchId: -1, SearchStr: this.defaultSearchEndDate.toISOString(), Title: 'End Date' },
            { Id: 26, SearchId: 1, SearchStr: '', Title: 'Evaluation MR' },
            { Id: 27, SearchId: 1, SearchStr: '', Title: 'Evaluation M' }

        ];
        this.filteredCustomers = Observable.of(this.selectionLists.customerList);
        this.filteredJobsites = Observable.of(this.selectionLists.jobSiteList);
        this.filteredFamilies = Observable.of(this.selectionLists.familyList);
        this.filteredMakes = Observable.of(this.selectionLists.makeList);
        this.filteredModels = Observable.of(this.selectionLists.modelList);
        this.filteredEquipments = Observable.of(this.selectionLists.equipmentList);
        this.filteredExaminers = Observable.of(this.selectionLists.examinerList);
        this.filteredDealer = Observable.of(this.selectionLists.dealerList);



        this.internalLimitedJobSites = this.selectionLists.jobSiteList;
        this.internalLimitedModels = this.selectionLists.modelList;
        this.internalLimitedEquipments = this.selectionLists.equipmentList;


        this.selectedComponentType = 0;


        this.internalLimitedCustomers = this.selectionLists.customerList;
        this.eqSearch = "";
        this.eqSearch = null;
        this.eqNotInUseSearch = "";
        this.eqNotInUseSearch = null;



        this.setInitialDates();
        this.ref.detectChanges();
    }

    ResetButtonClick() {
        this.setInitialDates();
        this._appService.GetLoggedInUserName().subscribe(result => { this.userName = result });
        // this._appService.getCustomerListForSelection(1, 10000).subscribe(result => { this.selectionLists.customerList = result; this.customerCtrl.reset(); });
        this._appService.getDealerForSelection(1, 10000).subscribe(result => {
            this.selectionLists.dealerList = result; this.dealerCtrl.reset();
        });

        this._appService.getCustomerListForSelection(1, 10000).subscribe(result => { this.selectionLists.customerList = result; this.internalLimitedCustomers = result; this.customerCtrl.reset(); });
        this._appService.getJobSiteListForSelection(1, 10000).subscribe(result => { this.selectionLists.jobSiteList = result; this.internalLimitedJobSites = result; this.jobsiteCtrl.reset(); });
        this._appService.getEquipmentListForSelection(1, 10000).subscribe(result => { this.selectionLists.equipmentList = result; this.internalLimitedEquipments = result; });

        this._appService.getFamilyListForSelection(1, 10000).subscribe(result => {
            this.selectionLists.familyList = this.filterMakeModelFamilyForExistingOnly ?
                result.filter(m => m.ExistingCount > 0) : result; this.familyCtrl.reset();
        });

        this._appService.getMakeListForSelection(1, 10000).subscribe(result => { this.selectionLists.makeList = this.filterMakeModelFamilyForExistingOnly ? result.filter(m => m.ExistingCount > 0) : result; this.makeCtrl.reset(); });
        this._appService.getGeneralInspectionInspectors().subscribe(result => {
            this.selectionLists.examinerList = result;
            this.selectionLists.examinerList.forEach(item => {
                item.EncryptedTitle = item.Title;
                item.Title = this._crypto.decrypt(item.Title);

            });
            this.examinerCtrl.reset();
        });

        this._appService.getModelListForSelection(1, 10000).subscribe(result => {
            this.selectionLists.modelList = this.filterMakeModelFamilyForExistingOnly ?
                result.filter(m => m).filter(m => m.ExistingCount > 0) : result.filter(m => m);
            this.internalLimitedModels = this.filterMakeModelFamilyForExistingOnly ?
                result.filter(m => m).filter(m => m.ExistingCount > 0) : result.filter(m => m); this.modelCtrl.reset();
        });

        this._appService.getUserSearchFavorites(1).subscribe(result => {
            this.userFavorites = result;
            this._appService.sendEnableSearch(true);
        }, error => console.log(error), () => { });
        this._appService.searchComponentIsExpanded.subscribe(isExpanded => this.showSearch = isExpanded);
        this._appService.showSearchComponentDateInputs.subscribe(showDateInputs => {
            this.showDateInputs = showDateInputs;
        });
        this._appService.showUserFilter.subscribe(showUser => {
            this.setSelectedTabs(showUser);
        });

        this.filteredCustomers =
            this.customerCtrl.valueChanges
                .startWith(null)
                .map(customerInput => customerInput ? this.filterCustomers(customerInput) : this.resetCustomer());
        this.filteredJobsites = this.jobsiteCtrl.valueChanges
            .startWith(null)
            .map(jobsiteInput => jobsiteInput ? this.filterJobsites(jobsiteInput) : this.resetJobsite());
        this.filteredEquipments = this.equipmentCtrl.valueChanges
            .startWith(null)
            .map(equipmentInput => equipmentInput ? this.filterEquipments(equipmentInput) : this.resetEquipment());
        this.filteredFamilies =
            this.familyCtrl.valueChanges
                .startWith(null)
                .map(familyInput => familyInput ? this.filterFamilies(familyInput) : this.resetFamily());
        this.filteredMakes =
            this.makeCtrl.valueChanges
                .startWith(null)
                .map(makeInput => makeInput ? this.filterMakes(makeInput) : this.resetMake());
        this.filteredModels =
            this.modelCtrl.valueChanges
                .startWith(null)
                .map(modelInput => modelInput ? this.filterModels(modelInput) : this.resetModel());
        this.filteredExaminers =
            this.examinerCtrl.valueChanges
                .startWith(null)
                .map(examinerInput => examinerInput ? this.filterExaminers(examinerInput) : this.resetExaminer());
        this.filteredDealer =
            this.dealerCtrl.valueChanges
                .startWith(null)
                .map(dealerInput => dealerInput ? this.filterDealer(dealerInput) : this.resetDealer());
        this.translateSubscription = this._translate._getPrefLang().subscribe(lang => setTimeout(() => { this.updateUserLang(lang); }, 2));
        this.multipleSelections = this._appService.getLastSelectionSearchItems();
        this.ref.detectChanges();
        this.selectedComponentType = 0;

        //console.log("type:", this.selectedComponentType)

    }
    clearInputBoxes(modelInput, makeInput, fInput, cInput, jInput, eInput, dInput) {
        this.selectedComponentType = 0;

        // if (modelInput) modelInput.value = '';
        // if (makeInput) makeInput.value = '';
        // if (fInput) fInput.value = '';
        // if (cInput) cInput.value = '';
        // if (jInput) jInput.value = '';
        // if (eInput) eInput.value = '';
        // if (dInput) eInput.value = '';

    }
    /**
     * Returns the default start date to be used in the shared
     * search component initially. This date is 3 months before
     * the current date.
     * @returns A date object.
     */
    get defaultSearchStartDate(): Date {
        const date = new Date(Date.now());
        date.setMonth(date.getMonth() - 3);
        return date;
    }

    /**
     * Returns the default end date to be used in the shared
     * search component initially. This date is 1 day ahead of the
     * current date.
     * @returns A date object.
     */
    get defaultSearchEndDate(): Date {
        const date = new Date();
        date.setDate(date.getDate() + 1);
        return date;
    }



}// End of header-top component class


import moment from 'moment';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MY_FORMATS } from '../../../modules/rope-shovel/pages/rope-shovel-inspection/rope-shovel-inspection.component';
import { ActivatedRoute } from '@angular/router';
import { ViewedInspectionTypes } from '../../../modules/inspection/models/find-inspection.model';
import { SharedService } from '../../services/SharedService';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CustomEvalService } from '../../../modules/CustomEval/custom-eval.service';
import { WSreStatusModel } from '../../../modules/CustomEval/custom-eval.model';
import { CryptoService } from '../../../services/crypto.service';
import { DashBoardModule } from '../../enums/allEnums';



@Component({
    selector: 'favorite-dialog',
    templateUrl: 'favorite-dialog.html',
    styleUrls: ['./header-top.component.scss']
})
export class FavoriteDialog {
    private userLanguage = 'english';
    public availableColors = [
        {
            Name: 'Blue',
            Colour: '#2F80ED'
        },
        {
            Name: 'Red',
            Colour: '#EB5757'
        },
        {
            Name: 'Green',
            Colour: '#6FCF97'
        },
        {
            Name: 'White',
            Colour: '#FFFFFF'
        },
        {
            Name: 'Black',
            Colour: '#333333'
        },
        {
            Name: 'Purple',
            Colour: '#BB6BD9'
        },
        {
            Name: 'Light Blue',
            Colour: '#56CCF2'
        },
        {
            Name: 'Orange',
            Colour: '#F2994A'
        }];
    public operation: FavOperation = FavOperation.Add;
    public model: SearchFavorite = new SearchFavorite();
    SetDefault = false

    constructor(
        public dialogRef: MatDialogRef<FavoriteDialog>,
        private _translate: TranslateService,
        @Inject(MAT_DIALOG_DATA) public data: any) {
        this.userLanguage = data.userLanguage;
        this.operation = data.operation;
        if (this.operation !== FavOperation.Add)
            this.model = data.favorite;
        this.SetDefault = this.model.isDefaultFavourite
    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }
    submitDialog(formIsValid: boolean) {
        if (!formIsValid)
            return;
        const result = new favPopUpModel();
        result.operation = this.operation;
        result.SearchFavorite = this.model;
        result.SearchFavorite.ModuleId = 1;
        this.dialogRef.close(result);
    }

    changeCheckbox() {
        this.SetDefault = !this.SetDefault
        // console.log(this.SetDefault)
        this.model.isDefaultFavourite = this.SetDefault
    }
    Translate(value: string): string {
        return this._translate.translateToLang(value, this.userLanguage);
    }


}
